import { rectSortingStrategy, SortableContext } from "@dnd-kit/sortable"
import { IMeal } from "../../types/types";
import SortableItem from "./SortableItem";
import { MealItem } from "../MealItem";
import { SetStateAction } from "react";

export const Droppable = ({
  id,
  meals,
  setMenu
}: {
  id: string,
  meals: (IMeal & { id: string })[],
  setMenu: (value: SetStateAction<IMeal[]>) => void
}) => {
  return (
    <SortableContext id={id} items={meals.map(({ id }) => id)} strategy={rectSortingStrategy}>
      <ul style={{ listStyle: "none", paddingLeft: 0 }}>
        {meals.map((meal) => (
          <SortableItem id={meal.id!} key={meal.id}>
            <MealItem meal={meal} setCart={setMenu} menu />
          </SortableItem>
        ))}
      </ul>
    </SortableContext>
  )
}
